/* eslint-disable @typescript-eslint/no-explicit-any */

import { useEffect, useState } from 'react';
import { DataAPIClientError } from './DataAPIClient';
import { useDataAPIClient } from './DataAPIClientProvider';
import { InboxEntity } from './types';

interface State {
  readonly data?: InboxEntity[];
  readonly error?: DataAPIClientError;
  readonly isLoading: boolean;
}

interface Result extends State {
  readonly refetch: (orgID: string) => Promise<void>;
}

export default function useDataAPIGetInboxesByOrgID(orgID?: string): Result {
  const client = useDataAPIClient();
  const [state, setState] = useState<State>({ isLoading: false });

  async function fetch(orgID: string): Promise<void> {
    setState({ isLoading: true });

    try {
      const data = await client.getInboxesByOrgID(orgID);

      setState({ isLoading: false, data });
    } catch (error: any) {
      setState({ isLoading: false, error });
    }
  }

  useEffect(() => {
    if (!orgID) return;

    fetch(orgID);
  }, [orgID]);

  return { ...state, refetch: fetch };
}
